var _effectorFileName = "/src/page-content/teachers/ui.tsx";
import { useTranslation } from 'next-i18next';
import { AboutTeachers } from '@/page-content/teachers/components/about-teachers';
import { Teachers } from '@/page-content/teachers/components/teachers';
import { MainLayout } from '@/widgets/layouts/main';
import { CallToAction } from '@/widgets/layouts/main/call-to-action';
import { ForWhomOurLessons } from '@/widgets/layouts/main/for-whom-our-lessons';
import { Reviews } from '@/widgets/layouts/main/reviews';
import { PageSeo } from '@/shared/lib/seo';
export const TeachersPage = () => {
  const {
    t
  } = useTranslation('teachers-page');
  return <>
      <PageSeo title={t('seo.title')} description={t('seo.description')} />

      <AboutTeachers />

      <Teachers />

      <ForWhomOurLessons />

      <Reviews />

      <CallToAction withForm />
    </>;
};
TeachersPage.Layout = MainLayout;